<app-loading *ngIf="loading"></app-loading>

<div class="lead-modal" *ngIf="!loading">
  <header class="modal-header">
    <div class="avatar" aria-hidden="true">{{ leadInitials }}</div>

    <div class="header-content">
      <div class="header-top">
        <div class="lead-name-block">
          <h2>{{ lead.name }}</h2>
          <div class="contact-row">
            <span class="contact-item" *ngIf="lead.phone">
              <mat-icon>call</mat-icon>
              <a [href]="applyWaLink(lead.phone)" target="_blank" rel="noopener noreferrer">{{
                lead.phone | whatsappPhone
              }}</a>
            </span>
            <span class="contact-item" *ngIf="lead.email">
              <mat-icon>mail</mat-icon>
              {{ lead.email }}
            </span>
          </div>
        </div>

        <button
          mat-icon-button
          class="close-button"
          type="button"
          aria-label="Fechar"
          (click)="closeModal()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="status-row">
        <span class="pill" [ngClass]="lead.statusTone">Status: {{ lead.status }}</span>
        <span *ngIf="lead.causeStatus" class="pill" [ngClass]="lead.causeStatusTone">
          Causa: {{ lead.causeStatus }}
        </span>
        <span class="pill pill--ghost">Origem: {{ lead.source }}</span>
      </div>
    </div>
  </header>

  <nav class="tab-bar">
    <button
      type="button"
      class="tab"
      [class.tab--active]="activeTab === 'info'"
      (click)="scrollToSection('informacoes-gerais', 'info')"
    >
      Informações Gerais
    </button>
    <button
      *ngIf="showFullDetails"
      type="button"
      class="tab"
      [class.tab--active]="activeTab === 'timeline'"
      (click)="scrollToSection('linha-do-tempo', 'timeline')"
    >
      Linha do Tempo
    </button>
    <button
      *ngIf="showFullDetails"
      type="button"
      class="tab"
      [class.tab--active]="activeTab === 'observations'"
      (click)="scrollToSection('observacoes', 'observations')"
    >
      Observações
    </button>
  </nav>

  <div class="modal-body">
    <section class="modal-section" id="informacoes-gerais">
      <div class="section-header">
        <div>
          <h3>Informações Gerais</h3>
          <p class="section-subtitle">Resumo completo do lead em um único lugar.</p>
        </div>
        <span class="chip">Criado em {{ lead.createdAt }}</span>
      </div>
      <div class="section-body">
        <div class="info-grid">
          <div class="info-item">
            <span class="info-label">Tipo de benefício</span>
            <span class="info-value">{{ lead.benefitType }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Situação previdenciária</span>
            <span class="info-value">{{ lead.previdenciaStatus }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Cidade / Estado</span>
            <span class="info-value">{{ leadLocation }}</span>
          </div>
        </div>

        <div class="info-note">
          <span class="info-label">Observação inicial</span>
          <p>{{ lead.initialObservation }}</p>
        </div>
      </div>
    </section>

    <section class="modal-section" id="linha-do-tempo" *ngIf="showFullDetails">
      <div class="section-header">
        <div>
          <h3>Linha do Tempo</h3>
          <p class="section-subtitle">Histórico auditável e não editável.</p>
        </div>
      </div>
      <div class="section-body">
        <ul class="timeline">
          <li class="timeline-item" *ngFor="let event of pagedTimeline" [ngClass]="event.tone">
            <div class="timeline-dot" [ngClass]="event.tone"></div>
            <div class="timeline-card">
              <div class="timeline-title">
                <span>{{ event.title }}</span>
              </div>
              <div class="timeline-status">
                <div class="timeline-status-item">
                  <span class="timeline-status-label">Status anterior</span>
                  <span class="pill" [ngClass]="event.previousStatusTone">
                    {{ event.previousStatus }}
                  </span>
                </div>
                <div class="timeline-status-item">
                  <span class="timeline-status-label">Status recente</span>
                  <span class="pill" [ngClass]="event.newStatusTone">
                    {{ event.newStatus }}
                  </span>
                </div>
              </div>
              <p class="timeline-detail" *ngIf="event.detail">{{ event.detail }}</p>
              <p class="timeline-meta">{{ event.user }} • {{ event.date }}</p>
            </div>
            <span class="timeline-time">{{ event.relative }}</span>
          </li>
        </ul>
        <div class="pagination">
          <button
            mat-icon-button
            type="button"
            class="pagination-button"
            (click)="changeTimelinePage(-1)"
            [disabled]="timelinePage === 1"
            aria-label="Anterior"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="page-indicator"> {{ timelinePage }} / {{ timelineTotalPages }} </span>
          <button
            mat-icon-button
            type="button"
            class="pagination-button"
            (click)="changeTimelinePage(1)"
            [disabled]="timelinePage === timelineTotalPages"
            aria-label="Proxima"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </section>

    <section class="modal-section" id="observacoes" *ngIf="showFullDetails">
      <div class="section-header">
        <div>
          <h3>Observações</h3>
          <p class="section-subtitle">Registre informações relevantes sobre o lead.</p>
        </div>
      </div>
      <div class="section-body">
        <mat-form-field appearance="outline" class="full-field">
          <mat-label>Adicionar observação</mat-label>
          <textarea
            matInput
            rows="3"
            placeholder="Adicionar observações relevantes..."
            [(ngModel)]="newObservation"
          ></textarea>
        </mat-form-field>

        <div class="observations-list">
          <div class="observation-card" *ngFor="let note of pagedObservations">
            <div class="observation-header">
              <span class="observation-author">{{ note.author }}</span>
              <span class="observation-date">{{ note.date }}</span>
            </div>
            <p class="observation-text">{{ note.text }}</p>
          </div>
        </div>
        <div class="pagination">
          <button
            mat-icon-button
            type="button"
            class="pagination-button"
            (click)="changeObservationsPage(-1)"
            [disabled]="observationsPage === 1"
            aria-label="Anterior"
          >
            <mat-icon>chevron_left</mat-icon>
          </button>
          <span class="page-indicator"> {{ observationsPage }} / {{ observationTotalPages }} </span>
          <button
            mat-icon-button
            type="button"
            class="pagination-button"
            (click)="changeObservationsPage(1)"
            [disabled]="observationsPage === observationTotalPages"
            aria-label="Proxima"
          >
            <mat-icon>chevron_right</mat-icon>
          </button>
        </div>
      </div>
    </section>
  </div>

  <div class="modal-footer-area" *ngIf="showFullDetails">
    <app-ui-modal-footer
      (secondary)="closeModal()"
      (primary)="saveChanges()"
      secondaryClass="cancel"
      primaryClass="save"
      secondaryLabel="Cancelar"
    ></app-ui-modal-footer>
  </div>
</div>
